import styled from 'styled-components';
import { Card } from 'react-bootstrap';

export const CardCampanhaWrapper = styled(Card)`
  width: 300px;
`;
